import { useEffect, useState } from "react";
import { SortedResultsList, useQuestionizerStore } from "../types/state.ts";
import {
  FDWAntragsteller,
  FDWResultEntry,
} from "../../../restfd2/fdw_result.ts";

export function QuestionizerResultSummary() {
  const plz = useQuestionizerStore((state) => state.plz);
  const gemeinde = useQuestionizerStore((state) => state.gemeinde);
  const gewerk_labels = useQuestionizerStore((state) =>
    state.getGewerkLabels()
  );
  const gebaeude = useQuestionizerStore((state) => state.gebaeude);
  const typ = useQuestionizerStore((state) => state.typ);
  const baujahr = useQuestionizerStore((state) => state.baujahr);
  const antragsteller = useQuestionizerStore((state) => state.antragsteller);
  const antragsteller_detail = useQuestionizerStore(
    (state) => state.antragsteller_detail
  );
  const _antragsteller =
    antragsteller?.length == 1 ? antragsteller[0] : antragsteller_detail;

  //console.log("LABELS:",gewerk_labels);

  return (
    <div className="mb-8">
      <p className="mb-8">
        Die Programminfos zu den ausgewählten Förderungen können direkt online
        eingesehen oder nach Auswahl gespeichert und ausgedruckt werden.
      </p>
      <section role="grid" className="summary">
        <h2 className="summary__title">Ihre Angaben</h2>

        <div role="row">
          <span role="cell" className="summary__bullet">
            Gewählte Maßnahmen
          </span>
          : <span role="cell">{gewerk_labels.join(", ")}</span>
        </div>

        <div role="row">
          <span role="cell" className="summary__bullet">
            Antragsteller
          </span>
          : <span role="cell">{FDWAntragsteller[_antragsteller!]}</span>
        </div>

        <div role="row">
          <span role="cell" className="summary__bullet">
            Ort
          </span>
          :{" "}
          <span role="cell">
            {plz} {gemeinde?.gemeinde_name}
          </span>
        </div>

        {gebaeude && (
          <div role="row">
            <span role="cell" className="summary__bullet">
              Gebäude
            </span>
            : <span role="cell">{gebaeude}</span>
          </div>
        )}

        {typ && (
          <div role="row">
            <span role="cell" className="summary__bullet">
              Typ
            </span>
            : <span role="cell">{typ}</span>
          </div>
        )}

        {baujahr && (
          <div role="row">
            <span role="cell" className="summary__bullet">
              Baujahr
            </span>
            : <span role="cell">{baujahr}</span>
          </div>
        )}
      </section>
    </div>
  );
}